/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import apiClient from '../api/client';
import { roleService } from './roleService';

// Mock data for sub-accounts as they weren't in the Postman collection
const MOCK_DELAY_MS = 500;
const MOCK_SUB_ACCOUNTS = [
  { uid: 'sub-1', name: 'Main Branch' },
  { uid: 'sub-2', name: 'Downtown Office' },
  { uid: 'sub-3', name: 'Westside Annex' }
];

export const userService = {
  /**
   * List Users - GET /api/users
   * Supports filtering by status and role via params
   */
  getUsers: async (params = {}) => {
    // Basic mapping of frontend param names to API expectations if needed
    // The API supports status and role filters
    return apiClient.get('/users', { params });
  },

  /**
   * Get User Detail - GET /api/users/:id
   */
  getUserById: async (id) => {
    return apiClient.get(`/users/${id}`);
  },

  /**
   * Create User - POST /api/users
   * Payload: firstName, lastName, displayName, email, password, role
   */
  createUser: async (payload) => {
    return apiClient.post('/users', payload);
  },

  /**
   * Update User - PATCH /api/users/:id
   * Partial updates for firstName, lastName, displayName, role, email
   */
  updateUser: async (id, payload) => {
    return apiClient.patch(`/users/${id}`, payload);
  },

  /**
   * Delete/Deactivate User - DELETE /api/users/:id
   * Soft deletes by setting status to inactive
   */
  deleteUser: async (id) => {
    return apiClient.delete(`/users/${id}`);
  },

  /**
   * Fetch available roles for assignment
   */
  getRoles: async () => {
    return roleService.getRoles({ limit: 1000 });
  },

  /**
   * Fetch sub-accounts for assignment
   * (Keeping mock until sub-account API is ready)
   */
  getSubAccounts: async () => {
    // Simulate slight delay for consistency
    await new Promise(resolve => setTimeout(resolve, MOCK_DELAY_MS));
    return { data: MOCK_SUB_ACCOUNTS };
  }
};
